import React, { FunctionComponent } from "react"
import useTranslate from "logic/hooks/use-translate"
import styled from "styled-components"
import tw from "twin.macro"
import { breakpoint } from "styles/breakpoints"
import { FormLabelsKeys, FORM_LABELS, FORM_ERRORS } from "model/messages"

interface FormControlProps {
  label?: FormLabelsKeys
  touched: boolean | undefined
  error: string
  alwaysLTR?: boolean
}

const Label = styled.label<{ invalid: boolean }>`
  ${tw`block px-2 text-sm font-bold order-1 h-5`}
  margin-bottom: 5px;
  color: var(--input-color);
`

const ErrorMessage = styled.p`
  ${tw`text-red px-2 text-sm font-bold order-3`}
  margin-top: 5px;
`

const StyledFormControl = styled.div<{
  invalid: boolean
  alwaysLTR: boolean
  noLabel: boolean
}>`
  ${tw`flex flex-col relative`}
  min-height: 6.2rem;
  ${({ alwaysLTR }) => alwaysLTR && "direction: ltr"};
  ${({ noLabel }) => noLabel && tw`pt-6`}

  ${({ invalid }) =>
    invalid &&
    `
    --input-color: #D22017;
  `}
`

const FormControl: FunctionComponent<FormControlProps> = ({
  children,
  touched,
  error,
  label,
  alwaysLTR = false,
}) => {
  const messages = useTranslate([...FORM_LABELS, ...FORM_ERRORS])
  const invalid = error && touched

  return (
    <StyledFormControl invalid={invalid} alwaysLTR={alwaysLTR} noLabel={!label}>
      {children}
      {label && <Label invalid={invalid}>{messages[label]}</Label>}
      {invalid && <ErrorMessage>{messages[error]}</ErrorMessage>}
    </StyledFormControl>
  )
}

export default FormControl
